import React, { useEffect, useState } from "react";
import PrimaryButton from "../common/buttons/PrimaryButton";
import SecondaryButton from "../common/buttons/SecondaryButton";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import Header from "../common/header/Header";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import MultiSelectWithCheckbox from "./multiselect-locations";
import { validateRecruiterEmail } from "../../js/api/recruiter";

const AddRecruiter = () => {
  const [clinicInfoId, setClinicInfoId] = useState([]);
  const [selectedClinicId, setSelectedClinicId] = useState("");
  const [selectedClinicName, setSelectedClinicName] = useState("");
  const [addFirstName, setAddFirstName] = useState("");
  const [addLastName, setAddLastName] = useState("");
  const [addRecruiterEmail, setAddRecruiterEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [toasts, setToasts] = useState([]);
  const [apiLoader,setApiLoader] = useState(false)
  const [popup, setPopup] = useState({ show: false, message: "", isError: false });
  const [multiSelectKey, setMultiSelectKey] = useState(0);
  const [recruiterEmailDomainError,setRecruiterEmailDomainError] = useState()

  
  // Fetch clinic data
  const fetchData = async () => {
    try {
      const res = await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO, );
      setClinicInfoId(res.data.data || []);
    } catch (error) {
       
      console.error("Error fetching clinic info:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const recruiterOptions = clinicInfoId.map((clinic) => ({
      value: clinic.name,
      label: clinic.name,
      id: clinic.clinicalInfoID, // Custom property to store ID
  }))

  // Handle location selection
  const handleSelectChange = (ids) => {
    const allIDS = ids.selectedIds
    setSelectedClinicId(allIDS);
  };

  // Validate all fields
  const validateFields = () => {
    const newErrors = {};

    if (!addFirstName.trim()) newErrors.addFirstName = "First name is required";
    if (!addLastName.trim()) newErrors.addLastName = "Last name is required";
    if (!addRecruiterEmail.trim()) {
      newErrors.addRecruiterEmail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(addRecruiterEmail)) {
      newErrors.addRecruiterEmail = "Invalid email format";
    }
    if (!selectedClinicId) newErrors.selectedClinicId = "Please select Location";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleAddRecruiter = async (e) => {
    e.preventDefault();

    if (!validateFields()) return;
    setApiLoader(true)
    const addRecruiterResponse = {
      firstName: addFirstName,
      lastName: addLastName,
      recruiterEmail: addRecruiterEmail,
      clinicalInfoIDs: selectedClinicId
    };

    try {
      const response = await axios.post(ENDPOINTS.RECRUITERS.ADD_RECRUITERS, addRecruiterResponse);
      // setPopup({ show: true, message: "The recruiter has been added successfully!", isError: false });
      
        setAddFirstName("");
        setAddLastName("");
        setAddRecruiterEmail("");
        setSelectedClinicId("");
        setSelectedClinicName("")
        setApiLoader(false)
        setMultiSelectKey(multiSelectKey + 1);
      
      addToast("Recruiter has been added successfully.", "success");
    } catch (error) {
    
      setApiLoader(false)
      addToast(error.response.data.message ||"Failed to add the recruiter.", "error");
      // setPopup({ show: true, message: error.message, isError: true });
    }
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const closePopup = () => {
    setPopup({ show: false, message: "", isError: false });
  };

  useEffect(() => {
  if(addRecruiterEmail){
    validateRecruiterEmail(addRecruiterEmail,setRecruiterEmailDomainError);
  }else{
    setRecruiterEmailDomainError('')
  }
  }, [addRecruiterEmail])

  return (
    <>
      <Header headertitle="Add Recruiter"  backbutton={true} />
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
      ))}
      <div className="main-body w-[80%] p-8">
        <div className="">
          <div className="text_color font-normal text-[16px] text-[#373737] font-mont">
            Seamlessly onboard and empower your recruitment team.
          </div>
          <form className="pb-20" onSubmit={handleAddRecruiter}>
            <div className="grid grid-cols-2 gap-8 pt-8">
              <div>
                <label for="firstName" class="block form_label_color pb-4">
                  First Name <span className="aestrick_color">*</span>
                </label>
                <input
                  type="text"
                  id="firstname"
                  name="firstName"
                  className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                  placeholder="Your First Name"
                  value={addFirstName}
                  onChange={(e) => setAddFirstName(e.target.value)}
                />
                {errors.addFirstName && <p className="text-red-500 text-sm">{errors.addFirstName}</p>}
              </div>
              <div>
                <label for="lastName" class="block form_label_color pb-4">
                  Last Name <span className="aestrick_color">*</span>
                </label>
                <input
                  type="text"
                  id="lastname"
                  name="lastName"
                  className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                  placeholder="Your Last Name"
                  value={addLastName}
                  onChange={(e) => setAddLastName(e.target.value)}
                />
                {errors.addLastName && <p className="text-red-500 text-sm">{errors.addLastName}</p>}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 pt-8">
              <div>
                <label htmlFor="recruiterEmail" className="block form_label_color pb-4">
                  Email ID <span className="aestrick_color">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  className="  border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                  placeholder="Your Email ID"
                  value={addRecruiterEmail}
                  onChange={(e) => setAddRecruiterEmail(e.target.value)}
                />
                {errors.addRecruiterEmail && <p className="text-red-500 text-sm">{errors.addRecruiterEmail}</p>}
                {recruiterEmailDomainError == "Email domain do not match to organization's domain" && <p className="text-red-500 text-sm">{recruiterEmailDomainError}</p>}
              </div>
              <div className="relative">
                <label
                  htmlFor="clinic"
                  className="block form_label_color pb-4"
                >
                  Select Location <span className="aestrick_color">*</span>
                </label>
                <div className="  border_color border text-sm rounded-lg block w-full p-1 appearance-none" style={{ minHeight: '3rem' }}>
                { recruiterOptions && (
                  <MultiSelectWithCheckbox 
                      options={recruiterOptions}
                      onChange={handleSelectChange}
                      key={multiSelectKey}
                  /> )
                }
                  
                </div>
                {errors.selectedClinicId && (
                  <p className="text-red-500 text-sm">{errors.selectedClinicId}</p>
                )}
              </div>

            </div>

            <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
              <button type="submit" className="btn-primary-base-bar primary_btn" disabled={apiLoader}>{apiLoader?<div className="flex justify-center"><div className="mini-spinner "></div></div>:"Add"}</button>
              <BackButton />
            </div>
          </form>
        </div>

        {popup.show && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
              <div className={`popup ${popup.isError ? "error" : "success"}`}>
                <p>{popup.message}</p>
                <button
                  onClick={closePopup}
                  className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>
            </div>
          </div>

        )}
      </div>
    </>
  );
};

export default AddRecruiter;
